import React from 'react';
import { Button, Result } from 'antd';
import useTranslation from 'utils/hooks/useTranslation';

// Shown instead of the dashboard when the wallet read fails for a reason other than "no wallet".
// The empty state is deliberately not used here: its CTA would try to create a second wallet.
const WalletLoadError = ({ onRetry }) => {
  const { translateText } = useTranslation();

  return (
    <div data-testid="walletLoadError">
      <Result
        status="warning"
        title={translateText('corporateAccounts.wallet.dashboard.error.title')}
        subTitle={translateText('corporateAccounts.wallet.dashboard.error.fetch')}
        extra={
          <Button type="primary" onClick={onRetry} data-testid="walletLoadErrorRetry">
            {translateText('corporateAccounts.wallet.dashboard.error.retry')}
          </Button>
        }
      />
    </div>
  );
};

export default WalletLoadError;
